import { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';
import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { AlertCircleIcon, IconFillColor, IconWrapper, Link, LinkSize, Tooltip } from '@dreryk/react-components';

import { VisitDiagnoses } from '~libs.shared.visit';

import { visitTranslationKeys } from '../../../../../translations';
import { MedicineReplacementModalOpenAction } from '../../../../../features/prescriptions/medicineReplacementModal/MedicineReplacementModalOpenAction';

import { StyledMedicineOutdatedIconTooltipContent } from './MedicineOutdatedIconTooltipContent.styled';

type MedicineOutdatedIconProps = {
   withdrawnMedicine: MedicineSimple;
   patientId: Patient['id'];
   medicineId: number;
   visitDiagnoses: VisitDiagnoses;
};

export const MedicineOutdatedIcon = (props: MedicineOutdatedIconProps): ReactElement => {
   return (
      <MedicineReplacementModalOpenAction
         withdrawnMedicine={props.withdrawnMedicine}
         patientId={props.patientId}
         medicineId={props.medicineId}
         visitDiagnoses={props.visitDiagnoses}
         source={'continuouslyUsedMedicine'}
      >
         {({ openModal }) => (
            <Tooltip
               testId={'medicineOutdated'}
               content={
                  <StyledMedicineOutdatedIconTooltipContent>
                     <Trans
                        i18nKey={visitTranslationKeys.common.medicineWithdrawnFromMarket}
                        components={{
                           link: (
                              <Link
                                 testId={'findAndReplaceMedicine'}
                                 label={visitTranslationKeys.common.findAndReplaceMedicine}
                                 size={LinkSize.SMALL}
                                 block={false}
                                 onClick={openModal}
                              />
                           ),
                        }}
                     />
                  </StyledMedicineOutdatedIconTooltipContent>
               }
            >
               <IconWrapper testId={'medicineOutdated'} fillColor={IconFillColor.BACKGROUND}>
                  <AlertCircleIcon />
               </IconWrapper>
            </Tooltip>
         )}
      </MedicineReplacementModalOpenAction>
   );
};
